import { createContext, useContext } from 'react'

export type Connection =
  | { kind: 'evm'; address: string; chainId?: string }
  | { kind: 'solana'; address: string }

export type WalletState = {
  connection: Connection | null
  hasEvm: boolean
  hasSolana: boolean
  connectEvm: () => Promise<void>
  connectSolana: () => Promise<void>
  disconnect: () => Promise<void>
}

export const WalletContext = createContext<WalletState | null>(null)

export function useWallet() {
  const v = useContext(WalletContext)
  if (!v) throw new Error('missing_wallet_provider')
  return v
}

